import { Entity, Field } from 'typegraph';

@Entity({one: "file", many: "files"})
export default class File {
	@Field()
	public url: string;
}



// WEBPACK FOOTER //
// ./src/panels/userSummary/entities/File.ts